import {SepaPolicies} from "@/authorization/policies/SepaPolicies";
import {SystemUserAdministratePolicies} from "@/authorization/policies/SystemUserAdministratePolicies";
import {UserDataPolicies} from "@/authorization/policies/UserDataPolicies";

export class ActivatedPolicies {
    public static PolicyArray =
        [
            SepaPolicies,
            SystemUserAdministratePolicies,
            UserDataPolicies,
        ];
}
